// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { ActiveStatus } from './active-status';
import { GuidelineContext } from './guideline-context';
import { GuidelineSeverity } from './guideline-severity';
import { Program } from './program';
import { Supplier } from './supplier';
import { ActiveStatusEnum } from './enums';
import { GuidelineContextEnum } from './enums';
import { GuidelineSeverityEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Guideline extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK account */
  accountId?: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** Enum FK guidelineContext */
  guidelineContextId!: GuidelineContextEnum;
  /** Enum FK guidelineSeverity */
  guidelineSeverityId?: GuidelineSeverityEnum;
  /** String */
  instruction?: string;
  /** Guid FK masterGuideline */
  masterGuidelineId?: string;
  /** Guid FK program */
  programId?: string;
  /** Binary */
  rowVersion!: any;
  /** Guid FK supplier */
  supplierId?: string;
  /** String(250) */
  title?: string;
  /** FK accountId */
  account!: Account;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** FK guidelineContextId */
  guidelineContext!: GuidelineContext;
  /** FK guidelineSeverityId */
  guidelineSeverity!: GuidelineSeverity;
  /** FK masterGuidelineId */
  masterGuideline!: Guideline;
  /** Inv FK masterGuidelineId */
  overrides!: Guideline[];
  /** FK programId */
  program!: Program;
  /** FK supplierId */
  supplier!: Supplier;
}

